// @flow
import styled from 'styled-components';
import React, {type Node} from 'react';
import {type DropdownOption} from '@tectonics/look-and-feel/volcanes/molecules/dropdown/dropdown-option';

type Props = {|
  option: DropdownOption,
  disabled: boolean,
  dataTestName: string,
  handleClick: () => void,
|};

export default function DropdownItem({option, disabled, dataTestName, handleClick}: Props): Node {
  return (
    <Item
      data-test-id={`${dataTestName}_dropdown_item_${option.value}`}
      key={option.value}
      onClick={() => {
        if (!disabled) {
          handleClick();
        }
      }}
    >
      {option.icon}
      <Text>
        {option.text}
      </Text>
    </Item>
  );
}

const Item = styled.li`
  display: flex;
  align-content: center;
  padding: 16px;
  gap: 8px;
  cursor: pointer;
  color: #4b5563;
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: #f3f4f6;
  }
`;

const Text = styled.p`
    font-family: ${props => props.theme.fontFamily.sansSerif};
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */
`;
